import { Api } from '../helpers';

const GeocodingModel = {
  getAutocompleteSuggestion(params) {
    const queryParams = params;
    const path = 'geocoding/get_autocomplete_suggestions';
    return Api.get({ path, queryParams });
  },

  GetPlaceDetails(params) {
    const queryParams = params;
    const path = 'geocoding/get_location_details';
    return Api.get({ path, queryParams });
  },
};

export default GeocodingModel;
